import React, { useState } from "react";
import { Modal, Button, Form, Input, Select } from "antd";
import { createCapability, fetchCapabilities } from "../../../redux/Capabilities/actions";
import { useDispatch } from "react-redux";

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export const AddCapabilityButton = () => {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        setVisible(true);
    };

    const hideModal_Ok = () => {
        form.submit();
    };

    const form_onfinish = (values) => {
        dispatch(createCapability(values)).then(() => {
            dispatch(fetchCapabilities());
        });
        form.resetFields();
        setVisible(false);
    };

    const hideModal_Cancel = () => {
        setVisible(false);
        form.resetFields();
    };

    return (
        <>
            <Button type="primary" onClick={showModal}>
                + Create
            </Button>
            <Modal
                title="Add Capability"
                visible={visible}
                onOk={hideModal_Ok}
                onCancel={hideModal_Cancel}
                okText="Submit"
                cancelText="Close"
            >
                <Form
                    {...layout}
                    name="basic"
                    form={form}
                    onFinish={form_onfinish}
                    initialValues={{ remember: false }}
                >
                    <Form.Item
                        label="Capability Name"
                        name="name"
                        rules={[
                            { required: true, message: "Please enter the capability name!" },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Capability Permission"
                        name="permission"
                        rules={[
                            {
                                required: true,
                                message: "Please select the capability permission!",
                            },
                        ]}
                    >
                        <Select placeholder="Select permission">
                            <Select.Option value="grant">Grant</Select.Option>
                            <Select.Option value="deny">Deny</Select.Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default AddCapabilityButton;
